import type { PropsWithChildren } from 'react';
import React from 'react';

import { CSSTransition, SwitchTransition } from 'react-transition-group';

import { transitionHandlers } from '@pages/auth/Registrations/const/transition-handler';

type TransitionContainerProps<T> = {
  step: T;
};
const { onEnter, onEntering, onExit, onExiting } = transitionHandlers;

export const TransitionContainer = <T,>({
  step,
  children,
}: PropsWithChildren<TransitionContainerProps<T>>) => {
  return (
    <SwitchTransition>
      <CSSTransition
        unmountOnExit
        onEnter={onEnter}
        onEntering={onEntering}
        onExit={onExit}
        onExiting={onExiting}
        key={step as React.Key}
        timeout={300}
      >
        {children}
      </CSSTransition>
    </SwitchTransition>
  );
};
